<template>
  <div>
    <filter-card :get-data-list="getDataList" />
    <b-card no-body>
      <b-card-body>
        <div class="text-right">
          <b-button
            variant="primary"
            :to="$route.path + '/add'"
          >
            <FeatherIcon icon="PlusIcon" /> Oluştur
          </b-button>
        </div>
      </b-card-body>
      <b-alert
        v-if="!dataList.length"
        class="m-2"
        variant="primary"
        show
      >
        <div class="alert-body text-center">
          <p><FeatherIcon icon="InfoIcon" /> Kayıtlı veri bulunmuyor.</p>
        </div>
      </b-alert>
      <template v-else>
        <b-table

          responsive="sm"
          :fields="fields"
          :items="dataList"
          striped
        >
          <template #cell(title)="data">
            {{ data.item.title }}
          </template>
          <template #cell(param_groups)="data">
            <div class="text-primary font-small-2 font-weight-bold">
              {{ data.item.param_groups }}
            </div>
            <div class="text-muted font-small-2">
              {{ data.item.param_sub_groups }}
            </div>
            <div class="text-danger font-small-2">
              Proje:
              {{ data.item.project? data.item.project : 'Genel' }}
            </div>
          </template>
          <template #cell(control)="data">
            <div class="text-right">
              <list-buttons
                :edit-action="$route.path + '/edit/' + data.item.id"
                :delete-action="removeData"
                :data-id="data.item.id"
              />
            </div>
          </template>
        </b-table>
        <b-card-footer>
          <b-pagination
            v-model="currentPage"
            :total-rows="dataCounts"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-card-footer>
      </template>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BCardBody, BTable, BPagination, BButton, BCardFooter, BAlert,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import FilterCard from '@/views/Params/FilterCard.vue'

const tableName = 'params'
export default {
  name: 'Index',
  components: {
    BAlert,
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    ListButtons,
    FilterCard,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'id',
          label: 'ID',
          thClass: 'width-50 text-nowrap',
          tdClass: 'width-50 text-nowrap',
        },
        {
          key: 'title',
          label: 'BAŞLIK',
        },
        {
          key: 'param_groups',
          label: 'PARAMETRE GRUBU',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.param_groups AS param_groups`,
          `${tableName}.param_sub_groups AS param_sub_groups`,
          `${tableName}.title AS title`,
          'projects.title AS project',
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['params/dataList']
    },
    dataCounts() {
      return this.$store.getters['params/dataCounts']
    },
    saveData() {
      return this.$store.getters['params/dataSaveStatus']
    },
    filterData() {
      return this.$store.getters['params/filterData']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.getDataList()
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
        this.getDataList()
      }
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      const where = {}
      if (this.filterData.param_sub_groups) {
        where['params.param_sub_groups'] = this.filterData.param_sub_groups
      }
      if (this.filterData.id_projects) {
        where['params.id_projects'] = this.filterData.id_projects
      }
      this.dataQuery.where = where
      this.$store.dispatch('params/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('params/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
